let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("jUhND"), load("2TjAk"), load("48ML3"), load("dA1E5"), load("e2946"), load("9Zo7z"), load("5o49p")]).then(() => parcelRequire('2iFkw'));